
import React from 'react';
import styled from 'styled-components';
import {
  themeGet,
  color,
  fontSize,
  fontStyle,
  fontWeight,
  letterSpacing,
  lineHeight,
  textTransform,
  borders,
  borderColor,
} from 'styled-system';

import {
  TextInput,
  bodyTypes,
  dataTypes,
  applyTextStyles,
} from '../../coreui';

/* eslint-disable indent */
const StyledInput = styled(TextInput)`
  text-indent: 12px;
  ${color}
  ${borders}
  ${borderColor}
  ${fontSize}
  ${fontStyle}
  ${fontWeight}
  ${letterSpacing}
  ${lineHeight}
  ${textTransform}
  box-sizing: ${props => props.boxSizing || 'content-box'};
  border-radius: 0;

  &:focus {
    border-color: ${themeGet('colors.blue.1')};
    outline-width: 0px;
  }

  &:disabled {
    color: ${themeGet('colors.gray.10')};
  }

  &::placeholder {
    color: ${themeGet('colors.gray.10')};
  }

  &.hf-validated:invalid {
    border-color: ${themeGet('colors.red')};
  }

  + .hf-warning {
    ${({ theme }) => applyTextStyles({
      theme,
      ...dataTypes.D4,
    })}
    color: ${themeGet('colors.red')};
    margin-top: 5px;
    margin-left: 12px;
  }
`;
/* eslint-enable indent */

const Input = ({
  required,
  forwardedRef,
  ...props
}) => {
  return (
    <StyledInput
      {...bodyTypes.B1}
      {...(forwardedRef ? {
        innerRef: forwardedRef,
      } : {})}
      color="gray.8"
      borderTop={0}
      borderLeft={0}
      borderRight={0}
      borderBottom={1}
      borderColor="gray.10"
      w={1}
      focusColor="blue.1"
      pt={7}
      pb={5}
      px={0}
      display="block"
      {...(required ? {
        required: 'required',
      } : {})}
      {...props}
    />
  );
};

export default Input;
